module.exports = __webpack_public_path__ + "img/logo_principal.f3ab3081.svg";